var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6064 22.75C12.4364 22.75 12.2664 22.75 12.0964 22.74C6.49643 22.49 1.81643 17.98 1.42643 12.48C1.08643 7.75999 3.81643 3.34999 8.21643 1.49999C9.46643 0.979992 10.1264 1.37999 10.4064 1.66999C10.6864 1.94999 11.0764 2.59999 10.5564 3.78999C10.0964 4.84999 9.86643 5.97999 9.87643 7.13999C9.89643 11.57 13.5764 15.33 18.0664 15.51C18.7164 15.54 19.3564 15.49 19.9764 15.38C21.2964 15.14 21.8464 15.67 22.0564 16.01C22.2664 16.35 22.5064 17.08 21.7064 18.16C19.5864 21.06 16.2164 22.75 12.6064 22.75ZM2.91643 12.37C3.25643 17.13 7.31643 21.03 12.1564 21.24C15.4464 21.4 18.5664 19.9 20.4864 17.28C20.6364 17.07 20.7064 16.92 20.7364 16.84C20.6464 16.83 20.4864 16.82 20.2364 16.87C19.5064 17 18.7464 17.05 17.9964 17.02C12.7164 16.81 8.39643 12.38 8.36643 7.15999C8.36643 5.77999 8.63643 4.44999 9.18643 3.19999C9.28643 2.97999 9.30643 2.82999 9.31643 2.74999C9.22643 2.74999 9.06643 2.76999 8.80643 2.87999C4.99643 4.47999 2.63643 8.29999 2.91643 12.37Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkness);
export default __webpack_public_path__ + "static/media/darkness.ec91bb0c37d875a141d45bb0b30910bc.svg";
export { ForwardRef as ReactComponent };